import React from 'react'
import { CardsGridForValue } from '../CardsGrid/CardsGrid'
import { Container,makeStyles } from '@material-ui/core'

export default function Values() {


    const useStyles = makeStyles({
        root: {
          display: 'flex'
        },
      });
    
      const classes = useStyles();
    

    return (
        <>
            <Container className={classes.root}>
                <CardsGridForValue />
            </Container>
        </>
    )
}
